var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -3850)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 3850)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.365 3863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.688,375.641a10.615,10.615,0,0,1-4.923,1.2h-3.146a10.62,10.62,0,0,1-4.924-1.2,9.526,9.526,0,0,0-3.207,7.121V384.3a.531.531,0,0,0,.534.528h18.34a.531.531,0,0,0,.534-.528v-1.539a9.526,9.526,0,0,0-3.207-7.121Zm0,0",
    transform: "translate(-119.556 -346.829)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.926,384.427v-1.539a9.455,9.455,0,0,1,1.4-4.958,3.108,3.108,0,0,1-.649-1.9c0-.084,0-.167.011-.249a9.526,9.526,0,0,0-3.2,7.11v1.539a.531.531,0,0,0,.534.528h2.434a.531.531,0,0,1-.534-.528Zm0,0",
    transform: "translate(-119.56 -346.955)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.117 28.807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.075,413.74a2.638,2.638,0,0,1-.575-.064v6.271h1.151v-6.271A2.638,2.638,0,0,1,249.075,413.74Zm0,0",
    transform: "translate(-242.557 -410.753)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.038,376.735a10.6,10.6,0,0,1-4.014-1.169c-.007.087-.012.176-.012.265a3.121,3.121,0,0,0,5.173,2.351A2.6,2.6,0,0,1,175.038,376.735Zm0,0",
    transform: "translate(-171.012 -375.567)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.7,375.57a10.6,10.6,0,0,1-4.014,1.168,2.6,2.6,0,0,1-1.147,1.448,3.121,3.121,0,0,0,5.173-2.351C278.716,375.746,278.712,375.657,278.7,375.57Zm0,0",
    transform: "translate(-265.679 -375.57)",
    fill: "#176eb5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.578,390.762h-3.146c-.338,0-.672-.016-1-.047a2.694,2.694,0,0,0,5.149,0C227.25,390.745,226.916,390.762,226.578,390.762Zm0,0",
    transform: "translate(-205.369 -360.746)",
    fill: "#ffc987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.938,202.518v-4.3c0-.007,0-.014,0-.021H55a2.5,2.5,0,0,0-2.5,2.477v2.071A2.5,2.5,0,0,0,55,205.22H56.3a10.361,10.361,0,0,1-.357-2.7Zm0,0",
    transform: "translate(-48.473 -182.993)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.306,198.195h-.937c0,.007,0,.014,0,.021v4.3a10.363,10.363,0,0,1-.357,2.7h1.294a2.5,2.5,0,0,0,2.5-2.477v-2.071A2.5,2.5,0,0,0,411.306,198.195Zm0,0",
    transform: "translate(-378.564 -182.993)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.692,78.725l-.111-.056v.451a.328.328,0,0,1-.146.272.331.331,0,0,1-.185.056.328.328,0,0,1-.123-.024l-4.062-1.62-.036.038a1.987,1.987,0,0,1-2.908,0l-.036-.038-4.061,1.62a.334.334,0,0,1-.309-.033.327.327,0,0,1-.146-.272v-.451l-.111.056a11.16,11.16,0,0,0-6.13,8.668v3.968A10.621,10.621,0,0,0,107,101.929h3.146a10.621,10.621,0,0,0,10.674-10.568V87.387a11.161,11.161,0,0,0-6.13-8.662Zm0,0",
    transform: "translate(-88.94 -71.837)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.777,119.1v-4.3a10.923,10.923,0,0,1,1.973-6.271,3.249,3.249,0,0,1-.292-.681,11.015,11.015,0,0,0-4.13,8.583V119.1A10.621,10.621,0,0,0,107,129.664h2.449A10.621,10.621,0,0,1,98.777,119.1Zm0,0",
    transform: "translate(-88.94 -99.572)",
    fill: "#e5bfa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.569,56.215a11.1,11.1,0,0,0-6.241,9.936v2.607a11.1,11.1,0,0,1,6.241-9.936Zm0,0",
    transform: "translate(-88.939 -51.903)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.3,56.215v2.607a11.1,11.1,0,0,1,6.241,9.936V66.151A11.1,11.1,0,0,0,334.3,56.215Zm0,0",
    transform: "translate(-308.663 -51.903)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.734,238.788c-2.717-.114-4.942,2.2-4.923,5.332,0,.386.3.568.681.433a12.89,12.89,0,0,1,8.484,0c.379.135.681-.047.681-.433.019-3.129-2.207-5.446-4.923-5.332Zm0,0",
    transform: "translate(-177.099 -220.468)",
    fill: "#fb8276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.947,238.9a4.461,4.461,0,0,0-1.213-.114c-2.717-.114-4.942,2.2-4.923,5.332,0,.386.3.568.681.433a12.853,12.853,0,0,1,1.745-.473A5.1,5.1,0,0,1,197.947,238.9Zm0,0",
    transform: "translate(-177.099 -220.468)",
    fill: "#e1756a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.8,23.813a1.954,1.954,0,0,1,.594-1.4l-4.137-1.651a.411.411,0,0,0-.381.04.405.405,0,0,0-.179.336v5.287a.4.4,0,0,0,.179.336.409.409,0,0,0,.229.07.4.4,0,0,0,.152-.029l4.09-1.631a1.952,1.952,0,0,1-.547-1.355Zm0,0",
    transform: "translate(-163.142 -19.14)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.58,20.8a.41.41,0,0,0-.38-.04l-4.137,1.651a1.954,1.954,0,0,1,.047,2.758L278.2,26.8a.4.4,0,0,0,.152.029.41.41,0,0,0,.228-.069.405.405,0,0,0,.18-.336V21.136A.405.405,0,0,0,278.58,20.8Zm0,0",
    transform: "translate(-253.042 -19.14)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.143,21.513l-1.888-.753a.41.41,0,0,0-.381.04.405.405,0,0,0-.179.336v5.287a.406.406,0,0,0,.179.336.411.411,0,0,0,.229.069.4.4,0,0,0,.152-.029l1.888-.753Zm0,0",
    transform: "translate(-163.142 -19.14)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.307,36.317a2.056,2.056,0,1,0-2.056,2.044A2.05,2.05,0,0,0,233.307,36.317Zm0,0",
    transform: "translate(-211.616 -31.644)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.854,36.317a2.043,2.043,0,0,1,1.227-1.87,2.044,2.044,0,1,0,0,3.74A2.043,2.043,0,0,1,230.854,36.317Zm0,0",
    transform: "translate(-211.616 -31.644)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.871,178.276a.575.575,0,0,1-.5-.287,2.787,2.787,0,0,0-3.8-1.016.575.575,0,1,1-.574-1,3.939,3.939,0,0,1,5.369,1.437.575.575,0,0,1-.5.863Zm0,0",
    transform: "translate(-273.029 -161.994)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.093,178.276a.575.575,0,0,1-.5-.863,3.939,3.939,0,0,1,5.369-1.436.575.575,0,1,1-.574,1,2.787,2.787,0,0,0-3.8,1.016A.575.575,0,0,1,142.093,178.276Zm0,0",
    transform: "translate(-130.664 -161.994)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,115.041a1.5,1.5,0,0,1-2.272,1.29l-2.145-1.173a.133.133,0,0,1,0-.233l2.145-1.173a1.5,1.5,0,0,1,2.272,1.29Zm0,0",
    transform: "translate(-418.731 -104.827)",
    fill: "#48e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.221.443a1.492,1.492,0,0,1-.693,2.515l-2.348.685a.133.133,0,0,1-.165-.165l.686-2.344a1.486,1.486,0,0,1,.394-.7,1.507,1.507,0,0,1,2.126.008Zm0,0",
    transform: "translate(-361.019 0)",
    fill: "#a2f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.784.443a1.492,1.492,0,0,0,.693,2.515l2.348.685a.133.133,0,0,0,.165-.165L76.3,1.135a1.483,1.483,0,0,0-.394-.7,1.507,1.507,0,0,0-2.126.008Zm0,0",
    transform: "translate(-67.715 0)",
    fill: "#48e5e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,115.037a1.5,1.5,0,0,0,2.271,1.29l2.146-1.173a.133.133,0,0,0,0-.233l-2.146-1.173a1.485,1.485,0,0,0-.774-.217A1.5,1.5,0,0,0,0,115.037Zm0,0",
    transform: "translate(0 -104.823)",
    fill: "#a2f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.095,240.45a1.5,1.5,0,0,1-1.509-1.494,1.482,1.482,0,0,1,.217-.773l1.175-2.141a.134.134,0,0,1,.234,0l1.175,2.141a1.482,1.482,0,0,1,.217.773A1.5,1.5,0,0,1,344.095,240.45Zm0,0",
    transform: "translate(-316.309 -217.873)",
    fill: "#a2f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.579,240.45a1.5,1.5,0,0,1-1.509-1.494,1.482,1.482,0,0,1,.217-.773l1.175-2.141a.133.133,0,0,1,.233,0l1.175,2.141a1.482,1.482,0,0,1,.217.773,1.5,1.5,0,0,1-1.509,1.494Zm0,0",
    transform: "translate(-120.094 -217.873)",
    fill: "#a2f9f9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby5);
export default __webpack_public_path__ + "static/media/baby5.ee5ebdfafa2b4623cf3a0ec2412e95ba.svg";
export { ForwardRef as ReactComponent };